import { useEffect } from "react"
import PropTypes from "prop-types"
import { isFunction } from "lodash"
import classNames from "classnames"
import "./style.scss"

function Upload({ children, onCancel, className }) {
  useEffect(() => {
    return () => isFunction(onCancel) && onCancel()
  }, [onCancel])

  return <div className={classNames("components_upload", className)}>
    <div className="upload-wrapper">
      {children}
    </div>
  </div>
}

Upload.propTypes = {
  className: PropTypes.string,
  onCancel: PropTypes.func,
}

export default Upload
